export interface Category {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  { slug: "re-xue", name: "热血", desc: "燃到骨子里的热血战斗与成长", icon: "ri-fire-line", color: "text-primary-600 bg-primary-100" },
  { slug: "lian-ai", name: "恋爱", desc: "甜到心里的恋爱与心动瞬间", icon: "ri-heart-3-line", color: "text-secondary-600 bg-secondary-100" },
  { slug: "zhi-yu", name: "治愈", desc: "温暖治愈的日常与心灵港湾", icon: "ri-sun-line", color: "text-accent-600 bg-accent-100" },
  { slug: "ke-huan", name: "科幻", desc: "脑洞大开的科幻与未来世界", icon: "ri-rocket-2-line", color: "text-foreground-700 bg-background-200" },
  { slug: "gao-xiao", name: "搞笑", desc: "笑点密集的沙雕欢乐日常", icon: "ri-emotion-laugh-line", color: "text-primary-600 bg-primary-100" },
  { slug: "mao-xian", name: "冒险", desc: "波澜壮阔的异世界冒险之旅", icon: "ri-compass-3-line", color: "text-accent-600 bg-accent-100" },
  { slug: "qi-huan", name: "奇幻", desc: "天马行空的魔法与奇幻史诗", icon: "ri-magic-line", color: "text-secondary-600 bg-secondary-100" },
  { slug: "sheng-huo", name: "日常", desc: "轻松平凡的青春校园日常", icon: "ri-cup-line", color: "text-foreground-700 bg-background-200" },
];